
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/playlist/recently-added",
      function () {
        return require("private-next-pages/playlist/recently-added.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/playlist/recently-added"])
      });
    }
  